import { InputAdornment, Tab, Tabs, TextField } from "@mui/material";
import { useState } from "react";
import { useGetAllServices } from "../api/services";
import { Search } from "../svgUrls";
import ServiceCard from "./Common/ServiceCard";

type TriggersListProps = {
    setSelectedService: (service: string) => void;
    showConditional?: boolean;
    triggerExists?: boolean;
}

const TriggersList = ({
    setSelectedService,
    showConditional,
    triggerExists
}: TriggersListProps) => {
    const [searchText, setSearchText] = useState('');
    const { data: services } = useGetAllServices();
    // const services = ["hubspot","slack","gmail","schedule","airtable","webhook","request","googlesheet"];

    const [tab, setTab] = useState('all');
    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
      setTab(newValue);
    };

    return <>
        <div className="text-lg font-medium">Run your workflow when...</div>
        <TextField
            size="small"
            placeholder="Search for an application"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
                endAdornment: <InputAdornment position="end"><Search /></InputAdornment>
            }}
            className="!my-4"
            inputProps={{
                className: '!text-xs'
            }}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
        />
        <div className="flex gap-8">
            {/* <Tabs
                orientation="vertical"
                variant="scrollable"
                value={tab}
                onChange={handleChangeTab}
                aria-label="Vertical tabs example"
                className="border-r border-solid border-borderGrey w-[140px]"
            >
                <Tab className="!capitalize" value="all" label="All triggers" />
                <Tab className="!capitalize" value="storage" label="Storage" />
                <Tab className="!capitalize" value="db" label="Database" />
                <Tab className="!capitalize" value="crm" label="CRM (Customer Relation)" />
                <Tab className="!capitalize" value="erp" label="ERP (Enterprise resource planning" />
            </Tabs> */}
            <div className="flex-1">
                {showConditional ?
                    <>
                        <div className="text-greyishBlueMid font-medium mb-4 text-3xs">ADD CONDITIONAL BLOCK</div>
                        <div className="flex gap-2 flex-wrap mb-4">
                            <ServiceCard
                                key='conditional-block'
                                className="basis-[calc(50%_-_8px)]"
                                serviceTitle="Conditions (If Then)"
                                serviceSubtitle="Create a filter to run a Node only on when conditions are True"
                                iconName="conditions"
                                onCardClick={() => setSelectedService('conditions')}
                            />
                        </div>
                    </>
                    : null
                }
                {/* <div className="text-greyishBlueMid font-medium mb-4 text-3xs">ALL TRIGGERS</div> */}
                <div className="flex gap-2 flex-wrap">
                    {
                        services?.
                            filter(({service}) => service.toLowerCase().includes(searchText.toLowerCase()))?.
                            filter(({actions}) => triggerExists || actions.some(action => [1,2].indexOf(action.type) !== -1))?.
                            sort((a, b) => a.service.toLowerCase().localeCompare(b.service.toLowerCase()))?.
                            map(
                            ({service}) => {
                                return <ServiceCard
                                    key={service}
                                    className="basis-[calc(50%_-_8px)]"
                                    serviceTitle={service}
                                    onCardClick={() => {
                                        setSelectedService(service)
                                    }}
                                />
                            }
                        )
                    }
                </div>
            </div>
        </div>
    </>
}

export default TriggersList;